/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedIconBubbleEmail_item$ref = any;
type PdpSharedIconBubbleFacebook_item$ref = any;
type PdpSharedIconBubblePinterest_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespIconBubbles_item$ref: FragmentReference;
export type PdpRespIconBubbles_item = {|
  +$fragmentRefs: PdpSharedIconBubblePinterest_item$ref & PdpSharedIconBubbleFacebook_item$ref & PdpSharedIconBubbleEmail_item$ref,
  +$refType: PdpRespIconBubbles_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespIconBubbles_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubblePinterest_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleFacebook_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_item",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '728b75da82490d73bad044aac0e7039d';
module.exports = node;
